import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { userApi } from '../../services/userApi';
import { UpdateUser } from '../../dtos/Users/index';
import { userKeys } from './useGetUser';

export function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Omit<UpdateUser, 'id'> }) =>
      userApi.update(id, data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully updated user');
        // Invalidate all user queries to refetch from server
        queryClient.invalidateQueries({ queryKey: userKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to update user'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to update user'}`);
    },
  });
}
